<template>
  <figure class="effect-zoe img-raised rounded">
    <img :src="photo" class="img" :alt="name + ' photo'" />
    <figcaption>
      <p class="m-0 w-100 font-weight-bold">{{name}}</p>
      <p v-if="jobTitle" class="mb-2 w-100 job-title">{{jobTitle}}</p>
      <p class="icon-links m-0 w-100">
        <a v-if="facebook" :href="'https://facebook.com/' + facebook" target="_blank" class="mx-2">
          <span class="fab fa-facebook-f"></span>
        </a>
        <a v-if="twitter" :href="'https://twitter.com/' + twitter" target="_blank" class="mx-2">
          <span class="fab fa-twitter"></span>
        </a>
        <a v-if="linkedin" :href="'https://linkedin.com/in/' + linkedin" target="_blank" class="mx-2">
          <span class="fab fa-linkedin"></span>
        </a>
        <a v-if="github" :href="'https://github.com/' + github" target="_blank" class="mx-2">
          <span class="fab fa-github-alt"></span>
        </a>
        <a v-if="gitlab" :href="'https://gitlab.com/' + gitlab" target="_blank" class="mx-2">
          <span class="fab fa-gitlab"></span>
        </a>
      </p>
    </figcaption>
  </figure>
</template>
<script>
export default {
  name: "team-avatar",
  props: {
    name: String,
    photo: String,
    jobTitle: String,
    facebook: String,
    twitter: String,
    github: String,
    linkedin: String,
    gitlab: String
  }
};
</script>
<style>
</style>
